import React from 'react';
import { Link, useLocation } from 'react-router-dom';
// import AccountServiceIcon from '../../../assets/images/accounts.png';
// import HelpIcon from '../../../assets/images/help-circle.png';
import SettingsIcon from '../../../assets/images/Settings.png';
import PersonalInfoImg from '../../../assets/images/user.png';
// import SecurityIcon from '../../../assets/images/security.png';
import documentsImg from '../../../assets/images/documents.png'
import SmartRoots from '../../../assets/images/SmartRoots.png';
import { isBase64 } from '../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { appTheme } from '../../../helpers/utils/Utils';
import { useTranslation } from 'react-i18next';
import { SAVINGS_GOALS } from '../../../network/URLConstants';
const Breadcrumbs = () => {
  const location = useLocation();
  const encryptedID = location.pathname.split('/').filter((segment) => segment.includes('='));
  const pathSegments = location.pathname.split('/').filter((segment) => segment !== '' && !segment.includes('='));
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue)
  const manageSavingDataObj = useSelector( (state) => state.manageSavingGoalDetailsObj);
  const loggedInResponses = useSelector(state => JSON.parse(state.loggedInResponse));
  const isTransferMoneyFeatureEnabled = loggedInResponses?.IsTransferMoneyFeatureEnabled === true;
  const cameFromManageMoney = location.state?.from === 'ManageMoney';
  const showManageMoneyCrumb = isTransferMoneyFeatureEnabled && cameFromManageMoney;
  const smiOneTrue = useSelector((state) => state?.smiOneAccountTrue);
  const { t } = useTranslation();
  const climbFeatures = useSelector((state) => state.climbFeatures);
  const selectedCardDetails = useSelector((state) => state.selectedCardDetails);
  const enabledClimbings = climbFeatures?.filter(
    (response) => response.enabled === true
  );
  const isSavingsGoalsOptedIn = enabledClimbings?.some(item => item.code === SAVINGS_GOALS && item.optedIn)

  // Slug groupings for shared labels
  const slugGroups = {
    spending: ['checking', 'spending'],
    addAuthorizedUser: ['addauthorizedusers', 'editauthorizeduser'],
    manageMembership: ['managemembershipscreen', 'managemembershipkudzu', 'managemembershipkudzuplus', 'managemembership'],
    connectSchool: ['connectschool', 'accesscode', 'edituniversity', 'universityseclection'],
    addBeneficiary: ['addbeneficiaries', 'editaddbeneficiary'],
    savingsGoals: ['savinggoals', 'allocatefund'],
    spendSenseAlerts: ['spendsensealerts', 'managespendalerts', 'addspendalerts'],
    savingsHabits: ['managesavingshabit', 'addsavingshabit', 'savingshabit'],
    toolkit: ['toolkitmenu', 'toolkit']
  }
  

  return (
    <nav>
      <ul className='flex flex-wrap sm:px-[6%] px-10 md:py-10 sm:py-6 py-4 gap-2'>
        {pathSegments.map((segment, index) => {

          const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
          const slugifiedSegment = segment.toLowerCase();
          const isActive = ((index === pathSegments.length - 1) && (pathSegments.length !== 1)) ? true : false;
          const isNotFirstSegment = index !== 0;
         
          // Skip rendering breadcrumb for 'toolkitmenu' to avoid duplication
          if (slugifiedSegment === 'toolkitmenu') {
              return null;
          }

          const linkPath = encryptedID.length > 0 && slugifiedSegment === 'edithabit' 
            ? `${path}/${encryptedID.join('/')}` 
            : slugifiedSegment === 'toolkit' 
              ? '/Toolkit/ToolkitMenu' 
              : (showManageMoneyCrumb && index === 0)
                ? '/ManageMoney'
                : path;

          const isDisabled = !isSavingsGoalsOptedIn && slugifiedSegment === 'savinggoals';
          const linkClassName = `lg:text-[20px] md:text-[18px] sm:text-[14px] text-[14px] font-hanken-grotesk font-[500] ${isDisabled ? 'opacity-50' : ''}`;

          const LinkWrapper = isDisabled ? 'span' : Link;
          const linkProps = isDisabled ? {} : { to: linkPath };

          if (showManageMoneyCrumb && index === 0) {
            return (
              <li
                className='font-hanken-grotesk flex lg:text-[20px] md:text-[18px] sm:text-[14px] text-[14px] leading-7 font-medium text-white'
                key={path}
              >
                <Link to={linkPath} className={linkClassName}>
                  <div className=' flex flex-row justify-start items-center'>
                    <img src={appThemeData.manageMoneyIcon} alt=""
                      className='sm:w-[18px] sm:h-[20px] w-[16px] h-[16px] md:w-[20px] md:h-[20px] ' />
                    <p className='sm:ml-3 ml-2 font-hanken-grotesk'>{t('Manage_Money')}</p>
                  </div>
                </Link>
              </li>
            );
          }

          return (
            <li
              className={`font-hanken-grotesk flex lg:text-[20px] md:text-[18px] sm:text-[14px] text-[14px]
               leading-7 font-medium ${isActive ? 'text-[#94C3E8]' : 'text-white'
                }`}
              key={path}
            >
              {isNotFirstSegment && <span className="slash mr-1">/</span>}
              <LinkWrapper {...linkProps} className={linkClassName}>
                {/* Account Services section */}
                {slugifiedSegment === 'accountservices' && (
                  <div className=' flex flex-row justify-start items-center'>
                    <img src={appThemeData.AccountServiceIcon} alt=""
                      className='sm:w-[18px] sm:h-[20px] w-[16px] h-[16px] md:w-[20px] md:h-[20px] ' />
                    <p className='sm:ml-3 ml-2 font-hanken-grotesk'>{t('account_services')}</p>
                  </div>
                )}
                {slugifiedSegment === 'managemoney' && (
                  <div className=' flex flex-row justify-start items-center'>
                    <img src={appThemeData.manageMoneyIcon} alt=""
                      className='sm:w-[18px] sm:h-[20px] w-[16px] h-[16px] md:w-[20px] md:h-[20px] ' />
                    <p className='sm:ml-3 ml-2 font-hanken-grotesk'>{t('Manage_Money')}</p>
                  </div>
                )}
                {slugifiedSegment === 'smionecard' && t('smione_card')}
                {slugGroups.spending.includes(slugifiedSegment) && t('spending')}
                {slugifiedSegment === 'manageauthorizedusers' && t('manage_authorized_users')}
                {slugGroups.addAuthorizedUser.includes(slugifiedSegment) && t('add_authorized_user')}
                {slugifiedSegment === 'addfunds' && t('add_funds')}
                {slugifiedSegment === 'addcash' && t('load_cash')}
                {slugifiedSegment === 'editaccountname' && t('edit_account_name')}
                {slugifiedSegment === 'managedirectdeposit' && t('set_up_direct_deposit')}
                {slugifiedSegment === 'transfermoney' && t('transfer_money')}
                {slugifiedSegment === 'addsecondarycardholder' && t('add_secondary_cardholder')}
                {slugifiedSegment === 'billpayments' && t('bill_payments')}
                {slugifiedSegment === 'personalinformation' && (
                  <div className=' flex flex-row justify-start items-center'>
                    <img src={PersonalInfoImg} alt="" className='sm:w-[18px] sm:h-[20px] w-[16px] h-[16px] md:w-[20px] md:h-[20px]' />
                    <p className='sm:ml-3 ml-2'>{t('personal_information')}</p>
                  </div>
                )}
                {slugifiedSegment === 'savings' && t('savings')}
                {slugifiedSegment === 'shared' && t('shared')}

                {/* Card Services section */}
                {slugifiedSegment === 'cardservices' && (
                  <div className=' flex flex-row justify-start items-center'>
                    <img src={appThemeData.cardservicesIcon} alt="" className='sm:w-[18px] sm:h-[20px] w-[16px] h-[16px] md:w-[20px] md:h-[20px]' />
                    <p className='sm:ml-3 ml-2'>{t('Card_Services')}</p>
                  </div>
                )}
                {slugifiedSegment === 'cardactionscreen' && (selectedCardDetails?.ProgramKey === 200 ? t('DebitCard') : t('smione_card'))}
                {slugifiedSegment === 'replacecard' && t('replace_card')}
                {slugifiedSegment === 'changepin' && t('change_pin')}
                {slugifiedSegment === 'viewcard' && t('view_card')}
                {slugifiedSegment === 'activatecard' && t('activate_card')}
                {slugifiedSegment === 'managerecurringpayments' && t('view_transaction_details')}
                {slugifiedSegment === 'details' && pathSegments[index - 1]?.toLowerCase() === 'managerecurringpayments' && t('manage_recurring_payments')}

                {/* Settings section */}
                {slugifiedSegment === 'settings' && (
                  <div className=' flex flex-row justify-start items-center'>
                    <img src={appThemeData.SettingBreadcrumbIcon}
                      alt="" className='sm:w-[16px] sm:h-[16px] w-[16px] h-[16px] md:w-[20px] md:h-[20px]' />
                    <p className='sm:ml-3 ml-2'>{t('settings')}</p>
                  </div>
                )}
                {slugGroups.manageMembership.includes(slugifiedSegment) && t('manage_membership')}
                {slugifiedSegment === 'manageexternalaccounts' && t('manage_external_accounts')}
                {slugifiedSegment === 'notificationconfigure' && t('configure_notifications')}
                {slugifiedSegment === 'manageaccounts' && t('manage_accounts')}
                {slugGroups.connectSchool.includes(slugifiedSegment) && t('connect_school')}
                {slugifiedSegment === 'addexternalaccount' && t('add_external_account')}
                {slugifiedSegment === 'verifyexternalaccount' && t('verify_external_account')}
                {slugifiedSegment === 'managebeneficiaries' && t('manage_beneficiaries')}
                {slugGroups.addBeneficiary.includes(slugifiedSegment) && t('add_beneficiary')}
                {slugifiedSegment === 'editbeneficiary' && t('edit_beneficiary')}

                {/* Help section */}
                {slugifiedSegment === 'help' && (
                  <div className=' flex flex-row justify-start items-center'>
                    <img src={appThemeData.helpcircleIcon} alt="" className='md:w-[19px] md:h-[20px] sm:w-[16px] sm:h-[16px] w-[14px] h-[14px]' />
                    <p className='sm:ml-3 ml-2'>{t('helpText')}</p>
                  </div>
                )}
                {slugifiedSegment === 'aboutkudzu' && t('about_kudzu')}
                {slugifiedSegment === 'faq' && t('helpfaq')}
                {slugifiedSegment === 'findatm' && t('find_an_atm')}
                {slugifiedSegment === 'contactus' && t('contact_us')}

                {/* Documents section */}
                {slugifiedSegment === 'documents' && (
                  <div className=' flex flex-row justify-start items-center'>
                    <img src={appThemeData.documentsIcon}
                      alt="" className='sm:w-[14px] sm:h-[15px] w-[16px] h-[16px] md:h-[20px] md:w-[20px]' />
                    <p className='sm:ml-3 ml-2'>{t('documents')}</p>
                  </div>
                )}
                {slugifiedSegment === 'kudzu' && t('kudzu')}
                {slugifiedSegment === 'smione' && t('smione')}
                {slugifiedSegment === 'policies' && t('policies')}
                {slugifiedSegment === 'fees' && t('fees')}
                {slugifiedSegment === 'statements' && t('statements')}
                {slugifiedSegment === 'taxdocuments' && t('tax_documents')}
                {slugifiedSegment === 'electronic%20communications%20disclosure%20and%20agreement' && t('electronic_communications_agreement')}
                {slugifiedSegment === 'kudzu%20user%20agreement' && t('user_agreement')}
                {slugifiedSegment === 'terms%20of%20use' && t('terms_of_use')}
                {slugifiedSegment === 'e-sign%20agreement' && t('esign_agreement')}
                {slugifiedSegment === 'cardholder%20agreement' && t('cardholder_agreement')}
                {slugifiedSegment === 'privacy%20policy' && t('privacy_policy')}
                {slugifiedSegment === 'fee%20schedule' && t('fee_schedule')}
                {slugifiedSegment === 'demand%20deposit%20account%20agreement' && t('demand_deposit_account_agreement')}
                {slugifiedSegment === 'official%20sweepstakes%20rules' && t('official_sweepstakes_rules')}
                {slugifiedSegment === 'savings%20rate%20information' && t('savings_rate_information')}
                {slugifiedSegment === 'savings%20account%20agreement' && t('savings_account_agreement')}
                {slugifiedSegment === 'kudzu%20privacy%20policy' && t('kudzu_privacy_policy')}
                {slugifiedSegment === 'bancorp%20privacy%20notice' && t('bancorp_privacy_policy')}
                {slugifiedSegment === 'covered%20by%20kudzu%20terms%20and%20conditions' && t('covered_by_kudzu_terms_and_conditions')}
                {slugifiedSegment === 'kudzu%20alerts%20terms%20of%20servies' && t('kudzu_alerts_terms_of_services')}
                {slugifiedSegment === 'deposit%20account%20agreement' && t('deposit_account_agreement')}

                {/* Security section */}
                {slugifiedSegment === 'security' && (
                  <div className=' flex flex-row justify-start items-center'>
                    <img src={appThemeData.securityIcon}
                      alt="" className={`${kudzuPlusTrue ? 'w-auto h-auto' : 'sm:w-[18px] sm:h-[20px] w-[16px] h-[16px]'}`} />
                    <span className='sm:ml-3 ml-2'>{t('security')}</span>
                  </div>
                )}
                {slugifiedSegment === 'changepassword' && t('change_password')}
                {slugifiedSegment === 'trusteddevice' && t('trusted_devices')}

                {/* Toolkit section */}
                {slugGroups.toolkit.includes(slugifiedSegment) && (
                  <div className=' flex flex-row justify-start items-center'>
                    <img
                      src={SmartRoots}
                      alt=""    
                      className='sm:w-[16px] sm:h-[16px] w-[16px] h-[16px]'
                    />
                    <p className='sm:ml-3 ml-2 font-hanken-grotesk'>{t('toolkit')}</p>
                  </div>
                )}
                {slugifiedSegment === 'toolkitsettings' && t('settings')}
                {slugGroups.savingsGoals.includes(slugifiedSegment) && t('savings_goals')}
                {slugifiedSegment === 'managesavinggoal' && t('manage_savings_goals')}
                {slugifiedSegment === 'managesavinggoaldetails' && (manageSavingDataObj?.goalName || '')}
                {slugifiedSegment === 'edit' && t('edit_savings_goal')}
                {slugGroups.spendSenseAlerts.includes(slugifiedSegment) && t('spendsense_alerts')}
                {slugifiedSegment === 'managecoveredbykudzu' && t('manage_covered_by_kudzu')}
                {slugifiedSegment === 'editspend' && t('edit_spendsense_alert')}
                {slugGroups.savingsHabits.includes(slugifiedSegment) && t('savings_habits')}
                {slugifiedSegment === 'edithabit' && t('edit_savings_habit')}
              </LinkWrapper>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
